module.exports = __webpack_public_path__ + "static/media/grimmszotar-new.c727ae79.svg";